/**
 * Skip link for keyboard users; targets an in-page landmark **`id`**.
 *
 * @param label - Accessible link text (catalog-backed).
 * @param targetId - Element **`id`** without leading **`#`** (for example **`main`**).
 * @returns Anchor with **`qz-skip-link`** class.
 */
export function createSkipLink(
  label: string,
  targetId: string,
): HTMLAnchorElement {
  const a = document.createElement("a");
  a.className = "qz-skip-link";
  a.href = `#${targetId}`;
  a.textContent = label;
  return a;
}
